<template>
  <div id="external-contact-detail" class="row" v-if="detail.id">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'External ID'|t }}:</td>
        <td>{{ detail.external_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Contact ID'|t }}:</td>
        <td>{{ detail.contact_cid }}</td>
      </tr>
      <tr>
        <td>{{ 'Object type'|t }}:</td>
        <td>{{ detail.object_type }}</td>
      </tr>
      <tr>
        <td>{{ 'Value Added Tax'|t }}:</td>
        <td>{{ detail.vat }}</td>
      </tr>
      <tr>
        <td>{{ 'Add information'|t }}:</td>
        <td>{{ detail.add_info }}</td>
      </tr>
      <tr v-if="'person' in detail">
        <td>{{ 'Address'|t }}:</td>
        <td>{{ detail.person.address.address }}, {{ detail.person.address.postal_code }}</td>
      </tr>
      <tr v-if="'person' in detail">
        <td>{{ 'Passport'|t }}:</td>
        <td>
          {{ 'ID'|t }}: {{ detail.person.passport.id }}<br>
          {{ 'Series'|t }}: {{ detail.person.passport.series }}<br>
          {{ 'Issue date'|t }}: {{ detail.person.passport.issue_date|date('date') }}<br>
          {{ 'Issued by'|t }}: {{ detail.person.passport.issue_org }}<br>
        </td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'Organization name'|t }}:</td>
        <td>{{ detail.org.name }}</td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'Organization telephone'|t }}:</td>
        <td>{{ detail.org.telephone }}</td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'Organization e-mail'|t }}:</td>
        <td>{{ detail.org.email }}</td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'FOC'|t }}:</td>
        <td>{{ detail.org.foc }}</td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'Legal address'|t }}:</td>
        <td>{{ detail.org.legal_address.address }}, {{ detail.org.legal_address.postal_code }}</td>
      </tr>
      <tr v-if="'org' in detail">
        <td>{{ 'Mailing address'|t }}:</td>
        <td>{{ detail.org.mailing_address.address }}, {{ detail.org.mailing_address.postal_code }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'UpdateForm',
    props: {
      ext_id: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      api.viewExternalContact(
        {external_id: self.ext_id},
        data => {
          self.detail = data;
        }
      )
    },
    data() {
      return {
        detail: {
          id: null,
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/external_contact/Detail.vue